import { Frame } from '@exam-center/app-frame';
import { Loading, styled } from '@shared/components';
import { NavigationHistoryProvider } from '@shared/navigation';
import { usePermission } from '@shared/permissions';
import type { PropsWithOptionalChildren } from '@shared/utils';
import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '../containers';
import { ServerTimeLayout } from '../layouts';

const Main = styled(Frame)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

type BaseLayoutProps = PropsWithOptionalChildren;

export default function BaseLayout(props: Readonly<BaseLayoutProps>) {
  const { children } = props;
  const { loading: isLoadingPermission } = usePermission();

  if (isLoadingPermission) {
    return <Loading fullscreen />;
  }

  return (
    <Main>
      <ProtectedRoute>
        <ServerTimeLayout>
          <NavigationHistoryProvider>{children ?? <Outlet />}</NavigationHistoryProvider>
        </ServerTimeLayout>
      </ProtectedRoute>
    </Main>
  );
}
